import { Box, useMediaQuery } from '@mui/material';
import { Switch, Route, useLocation } from 'react-router-dom';

import AdvisoryCloudLogo from '../components/AdvisoryCloudLogo';
import Treatment from '../components/Treatment';
import { featureFlags } from '../splitSetup';
import { useAccount } from '../contexts/Account';

import AOBFLayoutLegacy from './AOBFLayoutLegacy';
import MobileStep1 from '../scenes/CompanyOnboardingMobile/step1';
import MobileStep2 from '../scenes/CompanyOnboardingMobile/step2';
import MobileStep3 from '../scenes/CompanyOnboardingMobile/step3';
import MobileStep4 from '../scenes/CompanyOnboardingMobile/step4';
import MobileStep5 from '../scenes/CompanyOnboardingMobile/step5';
import MobileStep6 from '../scenes/CompanyOnboardingMobile/step6';
import MobileStep7 from '../scenes/CompanyOnboardingMobile/step7';

function AOBFMobileLayout() {
  const location = useLocation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 6,
        px: isMobile ? 0 : 2,
      }}
    >
      <Box sx={{ mb: isMobile ? 0 : 4 }}>
        <AdvisoryCloudLogo
          removeHyperlink
          onClick={() => {}}
          width={190}
          height={34}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          maxWidth: isMobile ? '100%' : 500,
        }}
      >
        <Switch>
          <Route
            exact
            path="/company/onboarding/step1"
            component={MobileStep1}
          />
          <Route
            exact
            path="/company/onboarding/step2"
            component={MobileStep2}
          />
          <Route
            exact
            path="/company/onboarding/step3"
            component={MobileStep3}
          />
          <Route
            exact
            path="/company/onboarding/step4"
            component={MobileStep4}
          />
          <Route
            exact
            path="/company/onboarding/step5"
            component={MobileStep5}
          />
          <Route
            exact
            path="/company/onboarding/step6"
            component={MobileStep6}
          />
          <Route
            exact
            path="/company/onboarding/step7"
            component={MobileStep7}
          />
        </Switch>
      </Box>
    </Box>
  );
}

function AOBFLayout() {
  const { currentUserInfo } = useAccount();

  return (
    <Treatment
      splitNames={featureFlags.mobile_b2b_aobf}
      evaluatedComponent={<AOBFMobileLayout />}
      conditionFailedComponent={<AOBFLayoutLegacy />}
      customId={currentUserInfo?.username}
    />
  );
}

export default AOBFLayout;
